import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { callDeletedItemsForTypePromise, FETCH_DELETED_ITEM_COUNTS_BY_MODULE } from "./sagas-actions";
import {
  onCallDeletedItemsForType,
  onFailedDeletedItemsForType,
  onSuccessDeletedItemsForType,
  onCallDeletedItemCountsByModule,
  onSuccessDeletedItemCountsByModule,
  onFailedDeletedItemCountsByModule
} from "./slice";
import { normalizeDeletedItemCountsByModule } from "./normalizeModuleCounts";
import { setError } from "store/error/slice";
import axiosInstance from "clients/api";
import { paramParserForPagination } from "utils/helpers";
import qs from "qs";
import { implementPromiseAction } from "@adobe/redux-saga-promise";

export const prefix = "/tenantUser/app_deleted_item";
const deletedItemCountByModulePath = "/tenantUser/deleted_item_count_by_module";

const typeColumnFilter = (typeName) => ({
  name: "Type",
  id: "Type",
  operator: "eq",
  type: "string",
  value: typeName
});

function mergeTypeFilter(typeName, paginationData) {
  const fv = paginationData?.filterValue || [];
  const rest = fv.filter((f) => f.name !== "Type" && f.id !== "Type");
  return {
    ...paginationData,
    filterValue: [...rest, typeColumnFilter(typeName)]
  };
}

function* deletedItemsForTypePromiseGenerator(action) {
  yield call(implementPromiseAction, action, function* deletedItemsByTypeWorker() {
    const { typeName, paginationData } = action.payload || {};
    const mergedPagination = mergeTypeFilter(typeName, paginationData);
    yield put(onCallDeletedItemsForType({ typeName, paginationData: mergedPagination }));
    try {
      const params = paramParserForPagination(mergedPagination);
      const queryString = qs.stringify(params);
      const { data } = yield call(axiosInstance.get, `${prefix}/table_data?${queryString}`);
      return yield put(onSuccessDeletedItemsForType({ typeName, data }));
    } catch (error) {
      yield put(
        setError({
          error,
          action
        })
      );
      yield put(onFailedDeletedItemsForType({ typeName }));
      return Promise.reject(error);
    }
  });
}

export function* deletedItemCountsByModuleGenerator(action) {
  yield put(onCallDeletedItemCountsByModule());
  try {
    const { data } = yield call(axiosInstance.get, deletedItemCountByModulePath);
    const normalized = normalizeDeletedItemCountsByModule(data);
    yield put(onSuccessDeletedItemCountsByModule(normalized));
  } catch (error) {
    yield put(
      setError({
        error,
        action
      })
    );
    yield put(onFailedDeletedItemCountsByModule());
  }
}

export default function* deletedItemsSaga() {
  yield takeEvery(callDeletedItemsForTypePromise, deletedItemsForTypePromiseGenerator);
  yield takeLatest(FETCH_DELETED_ITEM_COUNTS_BY_MODULE, deletedItemCountsByModuleGenerator);
}
